module.exports = __webpack_public_path__ + "1.5.0-unryo/img/all.8a006a1e.png";